export const DATA_EXPORT_STEPS = "DATA_EXPORT_STEPS";
export const DATA_EXPORT_OVERVIEW = "DATA_EXPORT_OVERVIEW";
export const DATA_EXPORT_SELECTED_TEST_ID = "DATA_EXPORT_SELECTED_TEST_ID";
export const DATA_EXPORT_SEARCH_QUERY = "DATA_EXPORT_SEARCH_QUERY";
export const DATA_EXPORT_EDIT_DATA = "DATA_EXPORT_EDIT_DATA";
export const DATA_EXPORT_TYPE = "DATA_EXPORT_TYPE";
export const DATA_EXPORT_SELECTED_ROWS_ID = "DATA_EXPORT_SELECTED_ROWS_ID";
export const DATA_EXPORT_SELECTED_ROWS_DATA = "DATA_EXPORT_SELECTED_ROWS_DATA";
export const DATA_EXPORT_SELECTED_STUDY_DATA = "DATA_EXPORT_SELECTED_STUDY_DATA";
